export function useClipboard() {
  return (url: string) => {
    if (!window.isSecureContext && !navigator.clipboard)
      // TODO: Fix this from eslint v9 update
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
      return Promise.reject();

    return navigator.clipboard.writeText(url);
  };
}
